<template>
  <div id="index">
    <v-header :link-class="url"></v-header>
    <section class="about_banner">
      <div class="about_banner_title">
        <div></div>
        <div>
          <h4>激发活力 助力成长</h4>
          <p>通过专业的培养体系与职业发展体系，激发组织与个人的活<br/>帮助员工与企业共同成长</p>
        </div>
      </div>
    </section>
    <section class="about_us">
      <ul class="about_us_item">
        <li v-for="(item,index) in abouts" :key="index">
          <img :src="item.icon" alt="">
          <p :style="{width:item.width}">{{item.content}}</p>
        </li>
      </ul>
      <div class="title">
        <p>关于我们</p>
        <i></i>
      </div>
      <div class="about_us_info">
        <div class="title">
          <p class="white_color">ABOUT US</p>
          <i class="white_bg"></i>
        </div>
        <p>迦尼传媒集团（JIANI media group）始于2003年，自成立以来坚持专业立身，历经近20年传承与发展，我们形成了国内领先的集品牌咨询管理、技术开发、整合营销、国际贸易、文旅资源整合为一体的核心服务体系，并创建了“IMC+SDA”互联网全产业链服务体系。公司立足互联网品牌服务领域，先后成创立易龙天高新技术开发有限公司、七星迪曼全案营销有限公司、柒柒恩贝（香港）国际贸易公司、中国政法大学企业互联网转型研究所等，并在上海、山西、重庆、湖南、内蒙古等设立办事处。</p>
      </div>
    </section>
    <section class="our_customers">
      <div class="title">
        <p>我们的客户</p>
        <i></i>
      </div>
      <ul>
        <li v-for="(item,index) in customers" :key="index">
          <img :src="item" alt="">
        </li>
      </ul>
    </section>
    <v-footer></v-footer>
  </div>
</template>
<script>
import header from '../../components/header/index'
import footer from '../../components/footer/index'
import icon1 from '@/assets/homeImages/icon1.png'
import icon2 from '@/assets/homeImages/icon2.png'
import icon3 from '@/assets/homeImages/icon3.png'
import icon4 from '@/assets/homeImages/icon4.png'
import icon5 from '@/assets/homeImages/icon5.png'

import kh1 from '@/assets/homeImages/kh1_07.png'
import kh2 from '@/assets/homeImages/kh1_03.png'
import kh3 from '@/assets/homeImages/kh1_09.png'
import kh4 from '@/assets/homeImages/kh1_01.png'
import kh5 from '@/assets/homeImages/kh1_05.png'
import kh6 from '@/assets/homeImages/kh1_11.png'
import kh7 from '@/assets/homeImages/kh1_13.png'
import kh8 from '@/assets/homeImages/kh1_15.png'
import kh9 from '@/assets/homeImages/kh2_02.png'
import kh10 from '@/assets/homeImages/kh2_03.png'
import kh11 from '@/assets/homeImages/kh2_05.png'
import kh12 from '@/assets/homeImages/kh2_06.png'
import kh13 from '@/assets/homeImages/kh2_08.png'
import kh14 from '@/assets/homeImages/kh2_10.png'
import kh15 from '@/assets/homeImages/kh2_12.png'
import kh16 from '@/assets/homeImages/kh2_14.png'
import kh17 from '@/assets/homeImages/kh2_16.png'
import kh18 from '@/assets/homeImages/kh2_25.png'
import kh19 from '@/assets/homeImages/kh2_26.png'
import kh20 from '@/assets/homeImages/kh2_27.png'
import kh21 from '@/assets/homeImages/kh2_29.png'
import kh22 from '@/assets/homeImages/kh2_30.png'
import kh23 from '@/assets/homeImages/kh2_31.png'
import kh24 from '@/assets/homeImages/kh2_32.png'
import kh25 from '@/assets/homeImages/kh2_41.png'
import kh26 from '@/assets/homeImages/kh2_42.png'
import kh27 from '@/assets/homeImages/kh2_43.png'
import kh28 from '@/assets/homeImages/kh2_44.png'
import kh29 from '@/assets/homeImages/kh2_45.png'
import kh30 from '@/assets/homeImages/kh2_46.png'
import kh31 from '@/assets/homeImages/kh2_47.png'
import kh32 from '@/assets/homeImages/kh2_48.png'
import getUrl from '../../mixin/getUrl/getUrl'
export default {
  name: 'home',
  mixins: [getUrl],
  components: {
    'v-header': header,
    'v-footer': footer
  },
  data () {
    return {
      abouts: [
        { icon: icon1, content: '一家企业互联网转型研究所', width: '140px' },
        { icon: icon2, content: '10个国家级平台规划落地经验', width: '117px' },
        { icon: icon3, content: '互联网专注20年', width: '100px' },
        { icon: icon4, content: '与22个世界500强深度合作', width: '150px' },
        { icon: icon5, content: '33个自主国家知识产权专利', width: '117px' }
      ],
      customers: [kh1, kh2, kh3, kh4, kh5, kh6, kh7, kh8, kh9, kh10, kh11, kh12, kh13, kh14, kh15, kh16, kh17, kh18, kh19, kh20, kh21, kh22, kh23, kh24, kh25, kh26, kh27, kh28, kh29, kh30, kh31, kh32]
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
  @maxWidth:1200px;

  #index {
    width: 100%;
    font-size: 0px;
    //公用
    .title {
      margin-top: 50px;
      p {
        font-size: 36px;
        color: #000;
        text-align: center;
        line-height: 100px;
        &.white_color {
          color: #fff;
        }
      }
      i {
        width: 100px;
        height: 4px;
        background-color: #ecbb72;
        display: block;
        border: 2px solid #fff;
        border-radius: 3px;
        margin: auto;
        &.white_bg {
          background: #fff;
        }
      }
    }
    //banner
    .about_banner {
      height: 968px;
      background: url("../../assets/homeImages/banner.jpg") no-repeat center center;
      display: flex;
      justify-content: center;
      align-items: center;
      .about_banner_title {
        display: flex;
        margin-right: 500px;
        div:nth-of-type(1) {
          width: 15px;
          height: 240px;
          background: #fff;
        }
        div:nth-of-type(2) {
          color: #fff;
          margin-left: 40px;
          h4 {
            font-size: 50px;
            font-weight: 400;
            letter-spacing: 5px;
            line-height: 40px;
          }
          p {
            font-size: 20px;
            line-height: 34px;
            margin-top: 100px;
          }
        }
      }
    }
    //关于我们
    .about_us {
      padding: 100px 0 0 0;
      .about_us_item {
        width: @maxWidth;
        margin: auto;
        display: flex;
        justify-content: space-between;
        li {
          width: 220px;
          height: 250px;
          background-color: #e7e7e7;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          p {
            /*margin: auto;*/
            text-align: center;
            line-height: 24px;
            font-size: 18px;
            margin-top: 25px;
          }
        }
      }
      .about_us_info {
        height: 400px;
        background: url("../../assets/homeImages/bj.png") no-repeat center center;
        margin-top: 100px;
        padding: 30px 0;
        &>p {
          width: @maxWidth;
          margin: 50px auto 0 auto;
          color: #fff;
          font-size: 20px;
          line-height: 36px;
        }
      }
    }
    //我们的客户
    .our_customers {
      ul {
        width: @maxWidth;
        display: flex;
        margin: 50px auto 0 auto;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        li {
          margin: 10px 10px;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    #index {
      width: 100%;
      padding-top: 1.2rem;
      //公用

      .title {
        margin-top: .5rem;
        p {
          font-size: .36rem;
          color: #000;
          text-align: center;
          line-height: 1rem;
          &.white_color {
            color: #fff;
          }
        }
        i {
          width: 1rem;
          height: .04rem;
          background-color: #ecbb72;
          display: block;
          border: .02rem solid #fff;
          border-radius: .03rem;
          margin: auto;
          &.white_bg {
            background: #fff;
          }
        }
      }
      //banner
      .about_banner {
        height: 3.68rem;
        background: url("../../assets/homeImages/banner.jpg") no-repeat center center;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .about_banner_title {
          display: flex;
          margin-right: 0;
          div:nth-of-type(1) {
            width: .15rem;
            height: 2.4rem;
            background: #fff;
          }
          div:nth-of-type(2) {
            color: #fff;
            margin-left: .4rem;
            h4 {
              font-size: .5rem;
              font-weight: 400;
              letter-spacing: .05rem;
              line-height: .4rem;
            }
            p {
              font-size: .2rem;
              line-height: .34rem;
              margin-top: 1rem;
            }
          }
        }
      }
      //关于我们
      .about_us {
        padding: 1rem 0 0 0;
        .about_us_item {
          width: 6.5rem;
          margin: auto;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          li {
            width: 2.4rem;
            height: 2.5rem;
            background-color: #e7e7e7;
            display: flex;
            margin: .2rem;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img {
              width: 1rem;
            }
            p {
              /*margin: auto;*/
              width: 1.5rem!important;
              text-align: center;
              line-height: .28rem;
              font-size: .18rem;
              margin-top: .25rem;
            }
          }
        }
        .about_us_info {
          height: 4rem;
          background: url("../../assets/homeImages/bj.png") no-repeat center center;
          background-size: 100% 100%;
          margin-top: 1rem;
          padding: 0 0 1rem 0;
          &>p {
            width: 6.5rem;
            margin: .5rem auto 0 auto;
            color: #fff;
            font-size: .2rem;
            line-height: .36rem;
          }
        }
      }
      //我们的客户
      .our_customers {
        ul {
          width: 6.5rem;
          display: flex;
          margin: .2rem auto 0 auto;
          justify-content: center;
          flex-wrap: wrap;
          li {
            margin: .1rem 0;
            text-align: center;
          }
        }
      }
    }
  }
</style>
